import React, { Fragment, useState, useEffect } from "react";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormGroup,
  Form,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import SweetAlert from "sweetalert2";
import DataTable from "react-data-table-component";
import { H3, Btn, Breadcrumbs, H4 } from "../../AbstractElements";
import { Link, useNavigate } from "react-router-dom";
import {
  deleteAccount,
  getAccount,
  getAllPackage,
  getpackageselect,
  packageReport,
} from "../../CommonURL";
import { getDataWithToken, postDataWithToken } from "../../Utils/restUtils";
import { Add } from "../../Constant";
import SearchList from "../../CommonElements/Search";
import Transparentspinner from "../Common/loader/Transparentspinner";
import IndustryFilter from "../Common/Filters/IndustryFilter";

const Package = () => {
  const style2 = { width: 60, fontSize: 13, padding: 3, marginRight: "10px" };
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };

  const [appliedFilters, setAppliedFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [packData, setPackData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [tempSearch, setTempSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchResetKey, setSearchResetKey] = useState(0);
  const [selectedPackage, setSelectedPackage] = useState("");
  const [packageOptions, setPackageOptions] = useState([]);
  const [isIndustry, setIsIndustry] = useState("");
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const packageReportColumns = [
    {
      name: <H4>Sl No</H4>,
      selector: (row) => row.Sl,
      sortable: true,
      width: "80px",
      center:true
    },

    {
      name: <H4>Packages</H4>,
      selector: (row) => row.Package,
      sortable: true,
    },
    {
      name: <H4>Industry</H4>,
      selector: (row) => row.Industry,
      sortable: true,
      wrap: true,
    },
    {
  name: <H4>No of Subscribers</H4>,
  selector: (row) => row.NoSubscribers,
  sortable: true,
  cell: (row) => (
    <div
     style={{
        cursor: "pointer",
        display: "inline-block",
        padding: "5px 12px",
        borderRadius: "12px",
        backgroundColor: "#e3f2fd",
        color: "#534686",
        fontWeight: "600",
        textAlign: "center",
        minWidth: "40px",
      }}
      onClick={() =>
        navigate("/subscriptions/active-sub", {
          state: {
            package_id: row.PackageId,
            package_name: row.Package,
            industry_id: row.IndustryId,
            industry_name: row.Industry,
            payment_status: "", 
          },
        })
      }
    >
      {row.NoSubscribers}
    </div>
  ),
},
  {
  name: <H4>Active Subscriptions</H4>,
  selector: (row) => row.ActiveSub,
  sortable: true,
  cell: (row) => (
    <div
       style={{
        cursor: "pointer",
        display: "inline-block",
        padding: "5px 12px",
        borderRadius: "12px",
        backgroundColor: "#e3f2fd",
        color: "#534686",
        fontWeight: "600",
        textAlign: "center",
        minWidth: "40px",
      }}
      onClick={() =>
  navigate("/subscriptions/active-sub", {
  state: {
    package_id: row.PackageId,
    package_name: row.Package,      
    industry_id: row.IndustryId,
    industry_name: row.Industry,   
    payment_status: "paid",
  },
})
}
    >
      {row.ActiveSub}
    </div>
  ),
},
    {
  name: <H4>Payment Pending</H4>,
  selector: (row) => row.ExpiredSub,
  sortable: true,
  cell: (row) => (
    <div
       style={{
        cursor: "pointer",
        display: "inline-block",
        padding: "5px 12px",
        borderRadius: "12px",
        backgroundColor: "#e3f2fd",
        color: "#534686",
        fontWeight: "600",
        textAlign: "center",
        minWidth: "40px",
      }}
      onClick={() =>
        navigate("/subscriptions/active-sub", {
          state: {
            package_id: row.PackageId,
            package_name: row.Package,
            industry_id: row.IndustryId,
            industry_name: row.Industry,
            payment_status: "pending",
          },
        })
      }
    >
      {row.ExpiredSub}
    </div>
  ),
}
  ];

  useEffect(() => {
    fetchPackageData(1, perPage, {});
  }, []);

  useEffect(() => {
    setSelectedPackage("");
    loadPackages(isIndustry);
  }, [isIndustry]);

  const updateSearchKeyword = (keyword) => {
    setTempSearch(keyword);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchPackageData(page, perPage, appliedFilters);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchPackageData(page, newPerPage, appliedFilters);
  };
  const handleFilter = () => {
    const filters = {
      search: tempSearch,
      industry_type_id: isIndustry?.value || "",
      package_id: selectedPackage || "",
    };

    setAppliedFilters(filters);
    setCurrentPage(1);
    fetchPackageData(1, perPage, filters);
  };
  const loadPackages = async (industryId) => {
    if (!industryId?.value) {
      setPackageOptions([]);
      setSelectedPackage("");
      return;
    }

    try {
      const res = await getDataWithToken(
        `${getAllPackage}?industry_type_id=${industryId.value}`,
      );
      if (res?.status === true && Array.isArray(res?.data)) {
        setPackageOptions(res.data);
      } else {
        setPackageOptions([]);
      }
    } catch (err) {
      setPackageOptions([]);
    }
  };
  const fetchPackageData = async (page = 1, size = perPage, filters = {}) => {
    setLoading(true);

    try {
      const query = new URLSearchParams({
        page,
        page_length: size,
        search: filters.search || "",
        industry_type_id: filters.industry_type_id || "",
        package_id: filters.package_id || "",
      }).toString();

      const res = await getDataWithToken(`${packageReport}?${query}`);

      const formattedData = res.data.data.map((e, index) => ({
        Sl: (page - 1) * size + index + 1,
        Package: e.package_name,
        Industry: e.industry_name,
        NoSubscribers: e.no_subscribers,
        ActiveSub: e.active_subscriptions,
        ExpiredSub: e.expired_subscriptions,
        IndustryId: e.industry_type_id,
        PackageId: e.package_id,
      }));

      setPackData(formattedData);
      setTotalRows(res.data.total || 0);
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };
  const fetchExportData = async () => {
    const query = new URLSearchParams({
      export: "package_report",
      search: appliedFilters.search || "",
      industry_type_id: appliedFilters.industry_type_id || "",
      package_id: appliedFilters.package_id || "",
    }).toString();

    const res = await getDataWithToken(`${packageReport}?${query}`);
    return res?.data || [];
  };
const exportPDF = async () => {
  setLoading(true);
  try {
    const data = await fetchExportData();

    const doc = new jsPDF();

    const rows = data.map((e, index) => [
      index + 1,
      e.package_name,
      e.industry_name,
      e.no_subscribers,
      e.active_subscriptions,
      e.expired_subscriptions,
    ]);

    autoTable(doc, {
      head: [["Sl", "Package", "Industry", "Subscribers", "Active", "Expired"]],
      body: rows,
    });

    doc.save("package_report.pdf");
  } catch (err) {
    console.log(err);
  }
  setLoading(false);
};
  const exportExcel = async () => {
    setLoading(true);
    try {
      const data = await fetchExportData();

      const formatted = data.map((e, index) => ({
        Sl: index + 1,
        Package: e.package_name,
        Industry: e.industry_name,
        Subscribers: e.no_subscribers,
        Active: e.active_subscriptions,
        Expired: e.expired_subscriptions,
      }));

      const ws = XLSX.utils.json_to_sheet(formatted);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Package Report");

      XLSX.writeFile(wb, "package_report.xlsx");
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };
  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs mainTitle="Package" parent="Report" title="Package" />
      <Card>
        <CardHeader className="d-flex justify-content-between align-items-center">
          <H3>Package Report</H3>
          <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
            <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4">
              Export <i className="icofont icofont-arrow-up"></i>
            </DropdownToggle>

            <DropdownMenu container="body">
              <DropdownItem onClick={exportExcel}>
                <i className="fa fa-file-excel-o me-2"></i> Excel
              </DropdownItem>

              <DropdownItem onClick={exportPDF}>
                <i className="fa fa-file-pdf-o me-2"></i> PDF
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </CardHeader>
        <div
          style={{
            paddingLeft: "22px",
            marginRight: "22px",
            marginBottom: "-20px",
          }}
        >
          {/* <div style={{ display: "flex", alignItems: "center", float: "left" }}>
            <SearchList />
            <button className="btn btn-primary  mb-2 ms-2  ">Filter</button>
          </div> */}
          <div className="px-4 pb-2">
            <Row className="g-3 align-items-center">
              <Col sm="12" md="5" lg="3" className="pt-3">
                <SearchList
                  className="form-control"
                  key={searchResetKey}
                  updateSearchKeyword={updateSearchKeyword}
                  onEnter={handleFilter}
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <IndustryFilter
                  IsIndustry={isIndustry}
                  setIsIndustry={setIsIndustry}
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <select
                  className="form-select"
                  value={selectedPackage}
                  disabled={!isIndustry?.value}
                  style={
                    !isIndustry?.value
                      ? {
                          backgroundColor: "#f5f5f5",
                          color: "#999",
                        }
                      : {}
                  }
                  onChange={(e) => {
                    setSelectedPackage(e.target.value);
                  }}
                >
                  <option value="">
                    {isIndustry?.value
                      ? "All Packages"
                      : "Select Industry First"}
                  </option>

                  {packageOptions.map((pkg) => (
                    <option key={pkg.id} value={pkg.id}>
                      {pkg.name}
                    </option>
                  ))}
                </select>
              </Col>
              <Col>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    float: "left",
                    gap: "10px",
                  }}
                >
                  <button
                    className="btn btn-primary mb-2 ms-2"
                    onClick={handleFilter}
                  >
                    Filter
                  </button>
                </div>
              </Col>
            </Row>
          </div>

          <div style={{ clear: "both" }}></div>
        </div>
        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
              columns={packageReportColumns}
              data={packData}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default Package;
